import { importProvidersFrom, NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule, Routes } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { OtpComponent } from './pages-public/otp/otp.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgbDropdownModule, NgbCollapseModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideAnimations } from '@angular/platform-browser/animations';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { SecureFileComponent } from './pages-private/secure-file/secure-file.component';
import { OtpGuard } from './service/otp-guard.service';
import { ToastrModule } from 'ngx-toastr';
import { TicketStatusAnonymousComponent } from './pages-public/ticket-status-anonymous/ticket-status-anonymous.component';

registerLocaleData(en);
const routes: Routes = [
	{ path: 'secfile/:smsId', component: OtpComponent },
	{ path: 'files', component: SecureFileComponent, canActivate: [OtpGuard] },
	{ path: 'ticket-status/:ticketReference', component: TicketStatusAnonymousComponent },

	//Catch All
	{ path: ':shortUrlCode', component: OtpComponent },
  	{ path: '**', redirectTo: 'null' }
];
@NgModule({
	declarations: [
		AppComponent,
		OtpComponent,
  		TicketStatusAnonymousComponent,
		SecureFileComponent
	],
	imports: [
		BrowserModule,
		NgbModule,
		RouterModule.forRoot(routes, { useHash: false }),
		FontAwesomeModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule,
		NgbDropdownModule,
		NgbCollapseModule,
		NgbProgressbarModule,
		NgbDatepickerModule,
	],
	providers: [
		provideClientHydration(),
		provideAnimations(),
		provideAnimationsAsync(),
		provideHttpClient(withInterceptorsFromDi()),
		importProvidersFrom(
			ToastrModule.forRoot({
				positionClass: 'toast-top-right',
				timeOut: 3000,
				progressBar: true,
				closeButton: true,
			})
		)
	],
	bootstrap: [AppComponent]
})
export class AppModule {
	constructor(library: FaIconLibrary) {
		library.addIconPacks(fas);
	}
}
